import React from 'react';

const DownOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="64 64 896 896" fill="currentColor" width="1em" height="1em" {...props}>
    <path d="M884 256h-75c-5.1 0-9.9 2.4-13 6.5L512 651.1 218 262.5a16.03 16.03 0 0 0-13-6.5H130c-6.5 0-10.4 7.4-6.5 12.7l382 493.6a16.03 16.03 0 0 0 25.1 0l382-493.6c3.9-5.3 0-12.7-6.6-12.7z" />
  </svg>
);

export default DownOutlined; 